// extracted by mini-css-extract-plugin
module.exports = {"socialEcomm":"SalePageLayout_socialEcomm__2hq9h"};